module.exports = __webpack_public_path__ + "img/681.66498e5e.jpg";